import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import DataTable from '../DataTable';
import { ALL, TRUE, FALSE } from '../../../Data/Constants';

class EventsAdminPage extends Component {
    columns = [
        {
            header: 'Név',
            id: 'name',
            cell: row => <NavLink to={`/admin/events/${row.id}`}>{row.name}</NavLink>
        },
        {
            header: 'Dátum',
            accessor: 'date',
            filterable: false,
            cell: row => new Date(row).toLocaleString("hu")
        },
        {
            header: 'Nyilvános',
            accessor: 'public',
            cell: row => row ? "Igen" : "Nem",
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{ width: "100%" }}
                    value={filter ? filter.value : { ALL }}
                >
                    <option value={ALL}>Mind mutatása</option>
                    <option value={TRUE}>Igen</option>
                    <option value={FALSE}>Nem</option>
                </select>
            )
        },
        {
            header: 'Létrehozva',
            id: 'creationDate',
            filterable: false,
            cell: row => (
                <span>
                    {new Date(row.creationDate).toLocaleString("hu")}{' '}
                    <small><em>({row.createdByUserName})</em></small>
                </span>
            )
        },
        {
            header: 'Utoljára módosítva',
            id: 'lastModificationDate',
            filterable: false,
            cell: row => {
                if (row.lastModificationDate !== null)
                    return (
                        <span>
                            {new Date(row.lastModificationDate).toLocaleString("hu")}{' '}
                            <small><em>({row.lastModifiedByUserName})</em></small>
                        </span>
                    );
                else return null;
            }
        },
        {
            header: 'Műveletek',
            sortable: false,
            id: 'actions',
            filterable: false,
            width: 300,
            cell: row => (
                <span>
                    <NavLink to={`/admin/events/${row.id}/registrations`}>Jelentkezések</NavLink>{' '}
                    <NavLink to={`/admin/events/${row.id}/tasks`}> Feladatok</NavLink>{' '}
                </span>
            )
        }
    ];

                    //<NavLink to={`/admin/events/${row.id}/payments`}> Pénzügyek</NavLink>
    render() {
        return (
            <>
                <h1>Rendezvények</h1>
                <DataTable url='/admin/events' columns={this.columns} />
                <NavLink className="btn btn-primary" to="/admin/events/create"><FontAwesomeIcon icon={faPlus} /> Új rendezvény</NavLink>
            </>
        );
    }
}

export default EventsAdminPage;
